import i18next from 'i18next';
import { FC, MouseEvent, ReactElement, SyntheticEvent, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ExerciseDto } from '../../../../shared/dtos/exercise.dto';
import AppModal from '../app-modal/AppModal';
import MediaPlayer from '../MediaPlayer';

const FALLBACK_THUMBNAIL: string = '/video_thumbnail.png';

type ExerciseMediaCellProps = {
  exercise: ExerciseDto;
};

const ExerciseMediaCell: FC<ExerciseMediaCellProps> = ({ exercise }: ExerciseMediaCellProps): ReactElement => {
  const [showPlayer, setShowPlayer] = useState(false);

  const title: string = i18next.language === 'de' ? exercise.deName : exercise.enName;

  const openPlayer = (event: MouseEvent<HTMLButtonElement>): void => {
    event.stopPropagation();
    setShowPlayer(true);
  };

  return (
    <>
      <button
        type="button"
        aria-label={i18next.t('exerciseModal.playPreview')}
        onClick={openPlayer}
        className="btn p-0 border-0 position-relative overflow-hidden rounded-3 shadow-sm"
        style={{ width: 112, height: 63, background: '#ececec' }}>
        <img
          src={exercise.hThumbnail ?? exercise.vThumbnail ?? FALLBACK_THUMBNAIL}
          alt=""
          loading="lazy"
          className="w-100 h-100"
          style={{ objectFit: 'cover' }}
          onError={(event: SyntheticEvent<HTMLImageElement>) => {
            if (event.currentTarget.src.endsWith(FALLBACK_THUMBNAIL)) {
              return;
            }
            event.currentTarget.src = FALLBACK_THUMBNAIL;
          }}
        />

        <span
          className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-circle"
          style={{ width: '1.75rem', height: '1.75rem', background: 'rgba(0, 0, 0, 0.55)' }}>
          <i className="fas fa-play text-white small" />
        </span>
      </button>

      <AppModal
        size="lg"
        centered
        show={showPlayer}
        onHide={() => setShowPlayer(false)}
        onClick={(event: MouseEvent) => event.stopPropagation()}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showPlayer && (
            <MediaPlayer
              exercise={exercise}
              height={420}
              autoPlay
              muted={false}
            />
          )}
        </Modal.Body>
      </AppModal>
    </>
  );
};

export default ExerciseMediaCell;
